// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_C1F","cls2":"buttonStyles-cls2_40t buttonStyles-cls1_C1F"};